import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useDropdownStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            position: 'relative',
            display: 'inline-block'
        },
        desktopDropdown: {
            'zIndex': 10,
            'padding': '7px 0px',
            'overflow': 'hidden',
            'borderRadius': 14,
            'position': 'fixed',
            'backgroundColor': '#fff',
            'border': '1px solid #000',

            '& > button': {
                'gap': 4,
                'margin': 0,
                'fontSize': 14,
                'lineHeight': 1,
                'fontWeight': 500,
                'fontFamily': 'Poppins',
                'textAlign': 'left',
                'width': '100%',
                'display': 'flex',
                'alignItems': 'center',
                'border': 'none',
                'padding': '8px 20px',
                'appearance': 'none',
                'background': 'none',

                '&:hover': {
                    background: '#F5F5F5'
                }
            }
        }
    })
);
